export const environment = {
  console: true,
  production: false,
  devUser: '',
  devPassword: '',

  ADMIN_AGENDA_URL: "#{ADMIN_AGENDA_URL}#",
  ADMIN_INDEX_URL: "#{ADMIN_INDEX_URL}#",
  API_URL: "#{API_URL}#",
  CODIGO_APLICACION: "#{CODIGO_APLICACION}#",
  ID_APLICACION: "#{ID_APLICACION}#",
  TPV_PATH: "#{TPV_PATH}#",
  NUMSERIE: "#{NUMSERIE}#",
  chClaveEmpresa: "#{chClaveEmpresa}#",
  chEntornoConexion: "#{chEntornoConexion}#",
  chNombreProyecto: "#{chNombreProyecto}#",
  chOrigenConexion: "#{chOrigenConexion}#",
  svgFolder: "#{svgFolder}#",
  API_URL_TAQUILLA: "#{API_URL_TAQUILLA}#",
  API_URL_MS: "#{API_URL_MS}#",
  API_TOKEN_USER: "#{API_TOKEN_USER}#",
  API_TOKEN_PASSWORD: "#{API_TOKEN_PASSWORD}#",
  CATEGORIA_FILTRO_AMIGO: "#{CATEGORIA_FILTRO_AMIGO}#",
  VERSION_FISCAL: "#{VERSION_FISCAL}#",

  HAS_LOGIN_MICROSOFT: "#{HAS_LOGIN_MICROSOFT}#",
  MSAL_CLIENT_ID: "#{MSAL_CLIENT_ID}#",
  MSAL_TENANT_ID: "#{MSAL_TENANT_ID}#",
  MSAL_AUTHORITY: "#{MSAL_AUTHORITY}#",
  MSAL_REDIRECT_URI: "#{MSAL_REDIRECT_URI}#",
  MSAL_POST_LOGOUT_REDIRECT_URI: "#{MSAL_POST_LOGOUT_REDIRECT_URI}#",
  MSAL_POST_LOGIN_REDIRECT_URI: "#{MSAL_POST_LOGIN_REDIRECT_URI}#",
  MSAL_SCOPES: ["#{MSAL_SCOPES}#"],
  MSAL_CACHE_LOCATION: "#{MSAL_CACHE_LOCATION}#",
  MSAL_LOG_LEVEL: "#{MSAL_LOG_LEVEL}#",
  MSAL_LOGIN_FAILED_ROUTE: "#{MSAL_LOGIN_FAILED_ROUTE}#",

  /*
  Valores PRE (descomentar bloque activo y comentar tokens para levantar en local):

  console: true,
  production: false,
  devUser: '',
  devPassword: '',
  ADMIN_AGENDA_URL: "https://taquilla.iacpospre.com/admin/Agenda.aspx",
  ADMIN_INDEX_URL: "https://taquilla.iacpospre.com/admin/MenuOperacionesEspeciales.aspx",
  API_URL: "https://apipre.apiacpos.com/2_16_0_bridge/",
  CODIGO_APLICACION: "PVKORE",
  ID_APLICACION: "1",
  TPV_PATH: "SCLPC101",
  NUMSERIE: "TAQU$A$N0QBO3AQ0$A$ILLA$A$CVW1R9537",
  chClaveEmpresa: "TICKAMORE_UNITARIO",
  chEntornoConexion: "PREPRODUCCION",
  chNombreProyecto: "TAQUILLA",
  chOrigenConexion: "TAQUILLA",
  svgFolder: "development",
  API_URL_TAQUILLA: "https://apipre.apiacpos.com/WebAPICoreBridge_1_8_0",
  API_URL_MS: "https://apipre.apiacpos.com/WebAPICoreBridge_1_8_0",
  API_TOKEN_USER: "admin@admin.com",
  API_TOKEN_PASSWORD: "IACPOS.2023a+",
  CATEGORIA_FILTRO_AMIGO: "",
  VERSION_FISCAL: "1.0.0",
  HAS_LOGIN_MICROSOFT: "false",
  */
};
